import { render, staticRenderFns } from "./wTable3.vue?vue&type=template&id=666ae9a4&"
import script from "./wTable3.vue?vue&type=script&lang=js&"
export * from "./wTable3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports